import { createContext } from 'react';
import { defaultContactsContextProps } from './constants';
export const ContactsPropsContext = /*#__PURE__*/createContext(defaultContactsContextProps);